module.exports = __webpack_public_path__ + "static/media/choose-payment.685f0a88.svg";